import React, { type FunctionComponent } from 'react'
import {
  colors,
  spacing,
  fontSize,
  EINA_01_FONT,
  fontWeight,
} from '@retailer-platform/shared-components'
import styled from '@emotion/styled'

type WrapperProp = {
  bgColor: string
}
const Wrapper = styled.div<WrapperProp>(props => ({
  height: spacing.X20,
  width: spacing.X20,
  backgroundColor: props.bgColor,
  borderRadius: '100%',
  fontSize: fontSize.X10,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: EINA_01_FONT,
  fontWeight: fontWeight.MEDIUM,
  color: colors.GRAYSCALE.X0,
  userSelect: 'none',
  flexShrink: 0,
  border: `2px solid ${colors.GRAYSCALE.X0}`,
}))

interface Props {
  count: number
}

export const NotifierIconWithCounts: FunctionComponent<Props> = ({ count }) => (
  <Wrapper bgColor={count > 0 ? colors.DETRIMENTAL.REGULAR : colors.GRAYSCALE.X30}>{count}</Wrapper>
)
